















import { Component, Vue } from 'vue-property-decorator';
import { refreshStores } from '@/containers/globals/globalSharedService';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { UserInfo, LoginInfo } from '@/types/type';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: {
    PortalAppBar,
    ErrorMessagePageTemplate,
  },
})
export default class PageNotFound extends Vue {
  private loading: boolean = true;

  private altMessage: String = 'Page Not Found';

  private imgName: String = 'page-not-found';

  private imgWidth: String = '250px';

  private imgHeight: String = '195px';

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    await refreshStores(loginInfo);
    this.loading = false;
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get titleText(): String {
    return i18n.tc('pageNotFound.titleText');
  }

  private get subText(): String {
    return i18n.tc('pageNotFound.subText');
  }

  private get goHomeText(): String {
    return i18n.tc('common.goHomeText');
  }

  private goHome(): void {
    router.push(PAGE_PATH_BY_NAME.portal);
  }
}
